import classNames from 'classnames'
import Icon from '@components/Icon'
import styles from './styles.module.scss'

const ResultListHeader = ({ resultsCount, toggleFilter, active = true }) => (
    <div className={styles.resultListHeader}>
        <div>
            {resultsCount} <T>map.results.count</T>
        </div>
        <div
            className={classNames(styles.filterControl, {
                [styles.active]: active,
            })}
            onClick={toggleFilter}>
            <Icon
                className={classNames('mr-2', {
                    [styles.active]: active,
                })}
                type="filter"
            />
            <T>map.filter.label</T>
        </div>
    </div>
)

export default ResultListHeader
